import { initializeApp } from "firebase/app";
// import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAw_at-uFcV-wSXBtrFF4111SYxg2cwwFY",
  authDomain: "markenbreit.firebaseapp.com",
  databaseURL: "https://markenbreit.firebaseio.com",
  projectId: "markenbreit",
  storageBucket: "markenbreit.appspot.com",
  messagingSenderId: "68039627416",
  appId: "1:68039627416:web:885c5d8b197fd9c00b36ed",
  measurementId: "G-5TKNLPDSCY"
};

const app = initializeApp(firebaseConfig);
// const appCheck = initializeAppCheck(app, { provider: new ReCaptchaEnterpriseProvider('6Lffm5kqAAAAAHXIaCapXIChyuVoy-DGV2AR4UoN'), isTokenAutoRefreshEnabled: true });
const database = getDatabase(app);

if (window.location.hostname === "localhost") {
  // Connect Firebase emulators for development environment
  connectDatabaseEmulator(database, "localhost", 9000);
}

export { 
  app as firebase,
  // appCheck,
  database,
};